import React from "react";
import NotFoundImg from '../../../assets/images/Page-not-found-404.png';
import styles from './index.module.css';

const NotFound = () => {
    return (
        <div className={`main-container`}>
            <div className={`container-content ${styles.imageContainer}`}>    
                <img src={NotFoundImg} alt="page not found" className={styles.imageClass}/>
            </div>
        </div>
    )
}

export default NotFound;